export const percentage = (partialValue: number, totalValue: number) => {
  if (partialValue >= 0 && totalValue > 0) {
    return Math.floor((partialValue * 100) / totalValue);
  }
  return 0;
};
